(function () {
'use strict';

const ANIMATION = {
  typing(options) {
    let count = 0;
    let timer = null;
    timer = setInterval(() => {
      if (count > options.text.length) {
        clearInterval(timer);
        options.end();
      } else {
        options.target.textContent = options.text.substring(0, count++);
      }
    }, options.interval);
  },
  fadeIn(options) {
    options.target.transformDuration = options.duration + 'ms';
    options.target.classList.add('active');
    setTimeout(() => {
      options.end();
    }, options.duration);
  },
  fadeOut(options) {
    options.target.transformDuration = options.duration + 'ms';
    options.target.classList.remove('active');
    setTimeout(() => {
      options.end();
    }, options.duration);
  },
  click(options) {
    options.target.addEventListener('click', () => {
      options.end();
    }, false);
  }
};

let audioCanPlay = true;

class Animate {
  constructor(options, trigger) {
    this.id = options.id;
    this.target = options.target;
    this.type = options.type;
    this.text = options.text;
    this.animation = options.animation;
    this.delay = options.delay;
    this.duration = options.duration;
    this.next = options.next;
    this.action = options.action;
    this.audio = options.audio;
    this.trigger = trigger;
  }
  play() {
    const animation = ANIMATION[this.animation];
    if (animation) {
      switch (this.animation) {
        case 'fadeIn':
          animation({
            target: this.target,
            duration: this.duration,
            end: () => {
              this.trigger(this.next);
            },
          });
          break;
        case 'typing':
          animation({
            target: this.target,
            text: this.text,
            interval: Math.round(this.duration / this.text.length),
            end: () => {
              this.trigger(this.next);
            },
          });
          break;
        case 'click':
          animation({
            target: this.target,
            end: () => {
              if (typeof this.action === 'function') {
                this.action();
              }
              this.trigger(this.next);
            },
          });
          break;
        default:
          break;
      }
      if (this.audio && audioCanPlay) {
        this.audio.play();
      }
    } else {
      throw new Error(`The type of ${ this.type } animation is missing!`);
    }
  }
}

class AnimateList {
  constructor(list, end) {
    this.list = list.map(item => {
      return new Animate(item, next => {
        this.trigger(next);
      });
    });
    this.end = end;
  }
  trigger(next) {
    const target = this.findNext(this.list, next);
    if (target) {
      setTimeout(() => {
        target.play();
      }, target.delay);
    } else {
      this.end();
    }
  }
  findNext(list, id) {
    if (id !== null) {
      for (let key in list) {
        if (list[key].id === id) {
          return list[key];
        }
      }
    }
    return null;
  }
  start() {
    this.list[0].play();
  }
}

class Page {
  constructor(options, end) {
    this.target = options.target;
    this.animation = options.animation;
    this.delay = options.delay;
    this.duration = options.duration;
    this.animationList = new AnimateList(this.findTarget(options.animationList), end);
  }
  findTarget(list) {
    return list.map(item => {
      if (item.target) {
        if (typeof item.target === 'string') {
          item.target = this.target.querySelector(item.target);
        }
      } else {
        item.target = this.target;
      }
      return item;
    });
  }
}

class PageList {
  constructor(list) {
    this.list = list.map(item => {
      return new Page(item, () => {
        this.next();
      });
    });
    this.current = 0;
  }
  show(page, end) {
    page.target.style.display = 'block';
    setTimeout(() => {
      end(page);
    }, page.duration);
  }
  hide(page, end) {
    page.target.style.display = 'none';
    [...page.target.querySelectorAll('audio')].forEach(item => {
      item.pause();
    });
    setTimeout(() => {
      end(page);
    }, page.duration);
  }
  next() {
    if (this.current === this.list.length) {
      this.end();
      return false;
    }
    if (this.current !== 0) {
      this.hide(this.list[this.current - 1], () => {
        this.show(this.list[this.current], page => {
          page.animationList.start();
          this.current++;
        });
      });
    } else {
      this.show(this.list[this.current], page => {
        page.animationList.start();
        this.current++;
      });
    }
  }
  start() {
    this.next();
  }
  end() {
    
  }
}

const pageList = new PageList([
  {
    target: document.querySelector('.page-1'),
    animation: 'fadeIn',
    delay: 0,
    duration: 300,
    animationList: [
      {
        id: 'page-1-1',
        target: '.depiction p',
        type: 'text',
        text: '你收到神秘邀请，来到这座遗落多年的古堡门前。门廊里排列着两列墓碑，空气中弥漫着腐朽的气息。',
        animation: 'typing',
        delay: 0,
        duration: 2000,
        next: 'page-1-2',
      },
      {
        id: 'page-1-2',
        target: '.gesture',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 300,
        next: 'page-1-3',
      },
      {
        id: 'page-1-3',
        type: 'action',
        animation: 'click',
        delay: 0,
        duration: 0,
        next: null,
      },
    ]
  },
  {
    target: document.querySelector('.page-2'),
    animation: 'fadeIn',
    delay: 0,
    duration: 300,
    animationList: [
      {
        id: 'page-2-1',
        target: '.depiction p',
        type: 'text',
        text: '你鼓起勇气，试图敲开大门，告诉主人你的到来，但门自动打开了。你小心翼翼踏入古堡之中，奇诡的装饰令人错愕。',
        animation: 'typing',
        delay: 0,
        duration: 2200,
        next: 'page-2-2',
      },
      {
        id: 'page-2-2',
        target: '.gesture',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 300,
        next: 'page-2-3',
      },
      {
        id: 'page-2-3',
        type: 'action',
        animation: 'click',
        delay: 0,
        duration: 0,
        next: null,
      },
    ]
  },
  {
    target: document.querySelector('.page-3'),
    animation: 'fadeIn',
    delay: 0,
    duration: 300,
    animationList: [
      {
        id: 'page-3-1',
        target: '.depiction p',
        type: 'text',
        text: '走进城堡，大堂昏暗无比，水晶灯台里的烛火明明灭灭地闪烁着。你不禁感到一丝寒意，正琢磨是什么人住在这里，这时突然响起一个人的声音……',
        animation: 'typing',
        delay: 0,
        duration: 3000,
        next: 'page-3-2',
      },
      {
        id: 'page-3-2',
        target: '.gesture',
        type: 'image',
        animation: 'fadeIn',
        delay: 0,
        duration: 300,
        next: 'page-3-3',
      },
      {
        id: 'page-3-3',
        type: 'action',
        animation: 'click',
        delay: 0,
        duration: 0,
        next: null,
      },
    ]
  },
]);

pageList.start();

[...document.querySelectorAll('audio')].forEach(item => {
  document.addEventListener('WeixinJSBridgeReady', function () {
    item.play();
    setTimeout(() => {
      item.pause();
    }, 0);
  }, false);
});

}());
